import { Dispatch, SetStateAction } from 'react';

import { useStorage } from '@gmm/ui';

import { useCurrentTeacher } from './useCurrentTeacher';

export const useTeacherStorage = <S>(
  key: string,
  initialValue: S | (() => S),
  storage?: Storage,
): [S, Dispatch<SetStateAction<S>>] => {
  const { data: teacher } = useCurrentTeacher();
  const getInitialValue = (): S =>
    typeof initialValue === 'function'
      ? (initialValue as () => S)()
      : initialValue;
  const storageKey = teacher ? `${teacher.id}.${key}` : key;

  return useStorage<S>(
    storageKey,
    (): S => {
      const oldStoredValue = window.localStorage.getItem(key);

      if (oldStoredValue === null) return getInitialValue();

      try {
        window.localStorage.removeItem(key);
        window.localStorage.setItem(storageKey, oldStoredValue);

        return JSON.parse(oldStoredValue);
      } catch {
        return getInitialValue();
      }
    },
    storage,
  );
};
